import React from 'react';
import { CompanyStatus } from '../../../../types/company';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { translate } from '../../../../types/translation/Translator';
import { itemsContainText } from '../../../../util/string.util';
import { MessageQuestionCircleIcon } from '../../../icons/MessageQuestionCircle/MessageQuestionCircleIcon';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import CompanyStatusFilterContent from './CompanyStatusFilterContent';
import CompanyStatusFilterInnerContent from './CompanyStatusFilterInnerContent';

export class CompanyStatusFilter extends BaseFilter<CompanyStatus> {
  constructor() {
    super();
  }

  toLabel(): string {
    return translate({ key: TranslationKey.companyStatus });
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.companyStatus?.size || 0;
  }

  toIcon(): JSX.Element {
    return <MessageQuestionCircleIcon className={this.className} />;
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return (
      <CompanyStatusFilterContent filter={this} filterProps={props.filterProps} setFilterProps={props.setFilterProps} />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <CompanyStatusFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  search(item: CompanyStatus, query: string): boolean {
    return itemsContainText(query, [item, translate({ key: item })]);
  }
}
